<template>
  <div class="pa-0 ma-0">
    <v-data-table
      :headers="headers"
      :items="userRights"
      :hide-default-footer="true"
      :no-data-text="$t('Generic.No_Data')"
      :no-results-text="$t('Manage_Users.UserRightsTable.NoSiteToDisplay')"
      class="elevation-0"
      dense
    >
      <template v-slot:item.site="{ item }">
        <selectable-sites
          :allSites="sites"
          :sitesLoading="sitesLoading"
          :selectedSites="selectedSiteIds"
          :selectedSite="item.siteId"
          v-on:site-selected="item.siteId = $event"
        >
        </selectable-sites>
      </template>
      <template v-slot:item.Admin="{ item }">
        <v-radio-group
          v-model="item.rightLevel"
          class="justify-center align-center"
        >
          <v-radio value="Admin" />
        </v-radio-group>
      </template>
      <template v-slot:item.Edit="{ item }">
        <v-radio-group v-model="item.rightLevel">
          <v-radio value="Edit" active-class="align-center" />
        </v-radio-group>
      </template>
      <template v-slot:item.View="{ item }">
        <v-radio-group v-model="item.rightLevel">
          <v-radio value="View" />
        </v-radio-group>
      </template>

      <template v-slot:item.Actions="{ item }">
        <v-btn
          text
          icon
          color="red"
          class="ma-0 pa-0"
          v-on:click="removeAccess(item.siteId)"
        >
          <v-icon class="ma-0 pa-0">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-btn class="mt-2" rounded depressed small v-on:click="addAccess">
      <v-icon color="primary" class="pr-1">mdi-plus</v-icon>
      {{ $t("Manage_Users.UserRightsTable.AddAccess") }}
    </v-btn>
  </div>
</template>
<script>
import ConstantsValues from "../../constants/constants";
import SiteService from "@/services/SiteService";
import SelectableSites from "./SelectableSites.vue";

export default {
  data() {
    return {
      sitesLoading: true,
      sites: [],
      headers: [
        {
          text: this.$i18n.t("Manage_Users.UserRightsTable.SiteName"),
          align: "left",
          value: "site",
          sortable: false
        },
        {
          text: this.$i18n.t("Generic.UserRights.Admin"),
          align: "left",
          value: ConstantsValues.Rights.Admin,
          sortable: false,
          width: "15%"
        },
        {
          text: this.$i18n.t("Generic.UserRights.Edit"),
          align: "left",
          value: ConstantsValues.Rights.Edit,
          sortable: false,
          width: "15%"
        },
        {
          text: this.$i18n.t("Generic.UserRights.View"),
          align: "left",
          value: ConstantsValues.Rights.View,
          sortable: false,
          width: "15%"
        },
        {
          text: this.$i18n.t("Generic.Actions"),
          value: "Actions",
          align: "center",
          sortable: false,
          width: "10%"
        }
      ]
    };
  },
  components: {
    SelectableSites
  },
  props: {
    userRights: Array
  },
  computed: {
    selectedSiteIds() {
      return this.userRights.map(ur => ur.siteId).filter(Boolean);
    }
  },
  methods: {
    removeAccess(id) {
      const index = this.userRights.findIndex(ur => ur.siteId === id);

      if (index > -1) {
        this.userRights.splice(index, 1);
        this.$emit("remove-right", {
          siteId: id
        });
      }
    },
    addAccess() {
      this.userRights.push({
        siteId: "",
        siteName: "",
        rightLevel: ConstantsValues.Rights.View
      });
    }
  },
  mounted() {
    SiteService.GetAllSites()
      .then(response => (this.sites = response.data))
      .catch(error =>
        this.$emit("show-error", this.$i18n.t("Error.Sites_Not_Retrieved"))
      )
      .finally(() => (this.sitesLoading = false));
  }
};
</script>
